import React, { useCallback } from 'react';
import { View } from 'react-native';

import { scale } from '@components/frame';
import { isPhone } from '@helpers';
import { getElementSizeConfig } from './helpers';

import BatchTile from '@v2/context/ProductionBatch/tile';
import { InlineErrorBoundary } from '@v2/components/errorBoundary';
import { BatchDetailsScreenName } from '@v2/pages/batch/details/navigation/config';
import { BatchDetailsScreen } from '@v2/pages/batch/details/common/enums/batchDetails.enum';
import { LevelSubScreen, Perspective } from '@v2/pages/common/enums';
import { connect } from 'react-redux';
import { BATCH_LIST_GAP, SCREEN_PADDING_HORIZONTAL, SCREEN_PADDING_VERTICAL } from '@v2/pages/common/constants/base.constants';
import { setBatchIdForHover, setShouldHoverBatch } from '@reducers/batch';
import { useFocusEffect } from '@react-navigation/native';
import { useDeviceSize } from '@v2/pages/common/hooks/useDeviceSize';
import { useHandleMainDetailsScreenNavigation } from '@v2/pages/common/hooks/useHandleMainDetailsScreenNavigation';

const BatchList = (props) => {
  const {
    batchList,
    selectedItem,
    batchListWidth,
    setBatchIdForHover,
    batchForHover,
    setShouldHoverBatch,
    withoutHorizontalPaddings,
    firstVisibleIndex,
    lastVisibleIndex,
    bg,
    withoutImage
  } = props;
  const { IS_NARROW_WEB } = useDeviceSize();
  const { navigateToMainDetailsScreen } = useHandleMainDetailsScreenNavigation();

  const elementSizeConfig = getElementSizeConfig(batchListWidth);

  useFocusEffect(
    useCallback(() => {
      const timeout = batchForHover.shouldHover
        ? setTimeout(() => {
            setShouldHoverBatch(false);
          }, 1000)
        : null;

      return () => {
        if (timeout) clearTimeout(timeout);
      };
    }, [batchForHover.shouldHover])
  );

  const onPress = async (item, levelSubScreen = LevelSubScreen.GENERAL) => {
    setBatchIdForHover(item.productionBatchId);

    navigateToMainDetailsScreen({
      mainScreen: BatchDetailsScreenName,
      subScreen: BatchDetailsScreen.BATCH,
      levelSubScreen,
      params: {
        perspective: Perspective.BATCH,
        batchNumber: item.batchNumber,
        batchId: item.productionBatchId,
        ncFileStatus: item.ncFileStatus,
        selectedImageKey: item.imageHash,
        documentId: item.imageDocumentId,
      },
    });
  };

  return (
    <View
      style={[
        { marginTop: scale(isPhone && !IS_NARROW_WEB ? SCREEN_PADDING_VERTICAL : 0) },
        !withoutHorizontalPaddings && { paddingHorizontal: scale(isPhone ? SCREEN_PADDING_HORIZONTAL : 0) },
      ]}
    >
      {batchList.map((batch, index) => (
        <View key={batch.productionBatchId} style={{ marginBottom: scale(BATCH_LIST_GAP) }}>
          <InlineErrorBoundary screenName="MachinesHistoryBatchTile" resetKey={batch.productionBatchId}>
            <BatchTile
              {...{ batch, onPress, selectedItem, index, firstVisibleIndex, lastVisibleIndex, width: batchListWidth, elementSizeConfig, bg, withoutImage }}
            />
          </InlineErrorBoundary>
        </View>
      ))}
    </View>
  );
};

export default connect(
  ({ machines: { selectedItem }, batch: { batchForHover } }) => ({
    selectedItem,
    batchForHover,
  }),
  { setBatchIdForHover, setShouldHoverBatch }
)(BatchList);
